"use strict";

exports.__esModule = true;
exports.LogbookComment = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LogbookContext = require("../LogbookContext");
var _Auth = require("../../Auth");
var _EditableLogbookComment = require("./EditableLogbookComment");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LogbookComment = exports.LogbookComment = function LogbookComment(_ref) {
  var comment = _ref.comment;
  var _React$useContext = _react["default"].useContext(_Auth.AuthContext),
    permissions = _React$useContext.permissions;
  var logbook = _react["default"].useContext(_LogbookContext.LogbookContext);
  var _useState = (0, _react.useState)(false),
    isEditing = _useState[0],
    setEditing = _useState[1];
  var ticketComment = {
    comment: comment,
    disabled: false,
    deletePermission: permissions.includes("comment:delete"),
    editPermission: permissions.includes("comment:update"),
    isAuthorized: permissions.includes("comment:update") || permissions.includes("comment:delete"),
    handleCommentEditClick: function handleCommentEditClick() {
      return setEditing(true);
    },
    onClose: function onClose() {
      return setEditing(false);
    },
    handleCommentEdit: function handleCommentEdit(comment, newBody) {
      logbook && logbook.updateComment(Object.assign({}, comment, {
        newBody: newBody
      }));
      setEditing(false);
    },
    handleCommentDeleteClick: function handleCommentDeleteClick() {
      logbook && logbook.deleteComment(comment);
      setEditing(false);
    },
    handleCancelCommentEdit: function handleCancelCommentEdit() {
      return setEditing(false);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_EditableLogbookComment.EditableLogbookComment, {
    comment: comment,
    ticketComment: Object.assign({}, ticketComment, {
      isEditing: isEditing
    })
  });
};